<template>
    <section class="loading-inside-component">
        <div class="loading-bg">&nbsp;</div>
        <div class="loading-wrap text-center">
            <v-progress-circular
                indeterminate
                color="primary"
            ></v-progress-circular>
        </div>
    </section>
</template>

<script>
export default {
    name: 'LoadingInsideComponent'
}
</script>

<style scoped>
    .loading-inside-component {
        position: absolute;
        display: block;
        width: 100%;
        height: 100%;
        overflow: hidden;
        z-index: 30;
    }
    .loading-bg {
        display: block;
        width: 100%;
        height: 100%;
        background: #edf0f5;
        opacity: 0.5;
        overflow: hidden;
        position: relative;
    }
    .loading-wrap {
        float: left;
        width: auto;
        height: auto;
        position: absolute;
        left: 50%;
        top: 50%;
        z-index: 2;
        transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        -webkit-transform: translate(-50%, -50%);
        -o-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
    }
</style>
